import type { CSSProperties } from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

export interface CSSVarSpacing extends CSSProperties {
  '--spacing'?: string;
}

export const heading = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${pxToRem(36)} 0 var(--spacing);
  margin: 0;
  border-top: 1px solid var(--neutral-black-30);
`;

export const title = css`
  ${theme.responsiveText.HEADING.XS}
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: 600;
  color: var(--neutral-black-base);
`;

export const icon = css`
  width: ${pxToRem(spacing.md)};
  height: ${pxToRem(spacing.md)};
`;
